import { datadogRum } from '@datadog/browser-rum';

export const addError = (error: Error) => {
  try {
    const currentUrl = window.location.href;
    const isExecutingLocal = currentUrl.includes('localhost');
    const enabled = process.env.REACT_APP_ENABLE_OBSERVABILITY;

    if (enabled && !isExecutingLocal) {
      const errorDatadog = new Error('Erro durante navegacao: ' + error);
      datadogRum.addError(errorDatadog);
    }
  } catch (err) {
    console.error('Erro ao usar API addError: ' + err);
  }
};
